import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { AvailableScorecardData, ScorecardToSubmit } from '../types/scorecardTypes';
import { hiringRequestQueries } from 'queryKeys/hiringRequest';
import { HiringRequestScorecard } from '../types/feedbackDetailTypes';
import customScorecardListAPI from 'api/customScorecardListAPI';
import hiringRequestsAPI from 'api/hiringRequestsAPI';

export const createHiringRequestScorecard = (
  hiringRequestId: number,
  payload: ScorecardToSubmit | FormData
): Promise<HiringRequestScorecard> => {
  return hiringRequestsAPI.createScorecard(hiringRequestId, payload).then((res) => res);
};

export const deleteHiringRequestScorecard = (
  hiringRequestId: number,
  scorecardId: number
): Promise<HiringRequestScorecard> => {
  return hiringRequestsAPI.deleteScorecard(hiringRequestId, scorecardId).then((res) => res);
};

export const editHiringRequestScorecard = (
  hiringRequestId: number,
  scorecardId: number,
  payload: ScorecardToSubmit | FormData
): Promise<HiringRequestScorecard> => {
  return hiringRequestsAPI.editScorecard(hiringRequestId, scorecardId, payload).then((res) => res);
};

export const useQueryGetAvailableScorecardsByRoleData = (
  roleId: number,
  options?: Omit<UseQueryOptions<AvailableScorecardData[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<AvailableScorecardData[], AxiosError> => {
  return useQuery({
    queryKey: ['availableScorecardsForRole', roleId],
    queryFn: () =>
      customScorecardListAPI.fetchCustomScorecardsByRole(roleId, true).then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useQueryGetScorecardsForHiringRequest = (
  hiringRequestId: number,
  options?: Omit<UseQueryOptions<HiringRequestScorecard[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<HiringRequestScorecard[], AxiosError> => {
  return useQuery({
    queryKey: hiringRequestQueries.hiringRequests.scorecards(hiringRequestId).queryKey,
    queryFn: () =>
      hiringRequestsAPI.getScorecardsForHiringRequest(hiringRequestId).then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
